import axios from "axios";
import { MDBDataTable } from "mdbreact";
import { useEffect, useMemo, useState } from "react";
import { MutatingDots } from "react-loader-spinner";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Label,
  Row,
} from "reactstrap";
import * as XLSX from "xlsx";
import api from "../../services/api";
import { setBreadcrumbItems } from "../../store/actions";
import "./datatables.scss";



const StudentRegistrationsCourseWiseList = (props) => {
  const navigate = useNavigate();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [courses, setCourses] = useState();
  const [selectedCourse, setSelectedCourse] = useState();
  const [technologies, setTechnologies] = useState();
  const [selectedTechnology, setSelectedTechnology] = useState();
  const [passoutYears, setPassoutYears] = useState();
  const [selectedPassoutYears, setSelectedPassoutYears] = useState(null);


  const breadcrumbItems = [
    { title: "Technical Hub", link: "#" },
    { title: "Student Registrations", link: "#" },
    { title: "Course Wise Registrations", link: "#" },
  ];

  /* ------------------------- Fetch Programs ------------------------- */



  useEffect(() => {
    getCourses();
    getPassoutYears();
  }, [])
  const getCourses = async () => {
    try {
      const response = await axios.get(`${backendUrl}get-courses`);
      if (response.status === 200) {
        setCourses(response.data);
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    const getTechnologies = async () => {
      if (selectedCourse?.value) {
        try {
          const response = await axios.post(`${backendUrl}get-technology-by-course-id`, {
            "course_id": selectedCourse.value
          });
          if (response.status === 200) {
            setTechnologies(response.data);
          }
        } catch (err) {
          console.log(err);
        }
      }
    }
    getTechnologies();
  }, [selectedCourse, backendUrl]);

  const getPassoutYears = async () => {
    try {
      const response = await axios.get(`${backendUrl}get-passout_year`);
      if (response.status === 200) {
        setPassoutYears(response.data);
      }
    } catch (err) {
      console.log(err);
    }
  }


  /* -------------------------- Fetch Registrations -------------------------- */
  const handleRegistrations = async () => {
    if (!selectedCourse || !selectedPassoutYears) {
      toast.error("Please select all required fields");
      return;
    }

    setSubmitted(true);
    setLoading(true);

    try {


      let filter = {
        course_id: selectedCourse.value,
        passout_year: selectedPassoutYears.value,
      };

      if (selectedTechnology) {
        filter.technology_id = selectedTechnology.value;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const response = await api.post(
        `${backendUrl}get-student-registrations-by-course-tech-and-passout-year`,
        filter
      );

      if (response.status === 200) {
        setRegistrations(response.data.data || []);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to fetch registrations");
    } finally {
      setLoading(false);
    }
  };



  // -------------------- CSV Download --------------------
  const downloadCSV = () => {
    if (registrations.length === 0) {
      toast.error("No data to download");
      return;
    }

    const headers = [
      "Roll No",
      "Name",
      "Course",
      "Technology",
      "Program",
      "Branch",
      "Mobile",
      "Gender",
      "College",
      "Passout Year",
    ];

    const rows = registrations.map(r => [
      r.roll_no || "-",
      r.first_name || "-",
      r.course_name || "-",
      r.technology_name || "-",
      r.program_name || "-",
      r.branch?.[0] || "-",
      r.college || "-",
      r.mobile || "-",
      r.gender || "-",
      r.passout_year || "-",
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map(e => e.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Student_Registrations.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const handleSelectedCourse = (selectedOption) => {
    setSelectedCourse(selectedOption);
    setSelectedTechnology(null);
    setSelectedPassoutYears(null);
    setRegistrations([]); // clear table
    setSubmitted(false);
  };


  const courseOptions = courses?.map((ele) => {
    return { label: ele.course_name, value: ele._id }
  });


  const handleSelectedTechnology = (selectedOption) => {
    setSelectedTechnology(selectedOption);
    setRegistrations([]);
    setSubmitted(false);
  };

  const technologyOptions = technologies?.map((ele) => {
    return { label: ele.technology_name, value: ele._id }
  });


  const handlePassoutYears = (selectedOption) => {
    setSelectedPassoutYears(selectedOption);
    setRegistrations([]);
    setSubmitted(false);
  };

  const passoutYearsOptions = passoutYears?.map((ele) => {
    return { label: ele.label, value: ele.value };
  });

  // -------------------- Excel Download --------------------
  const downloadExcel = () => {
    if (registrations.length === 0) {
      toast.error("No data to download");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(
      registrations.map(r => ({
        "Roll No": r.roll_no || "-",
        "Name": r.first_name || "-",
        "Course": r.course_name || "-",
        "Technology": r.technology_name || "-",
        "Program": r.program_name || "-",
        "branch": r.branch?.[0] || "-",
        "Mobile": r.mobile || "-",
        "Gender": r.gender || "-",
        "College": r.college || "-",
        "Passout Year": r.passout_year || "-",
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Registrations");

    XLSX.writeFile(workbook, "Student_Registrations.xlsx");
  };

  /* ----------------------------- Data Table ----------------------------- */
  const data = useMemo(
    () => ({
      columns: [
        { label: "S.No", field: "S_no", sort: "asc" },
        { label: "Roll No", field: "roll_no", sort: "asc" },
        { label: "Name", field: "first_name", sort: "asc" },
        { label: "Course", field: "course_name", sort: "asc" },
        { label: "Technology", field: "technology_name", sort: "asc" },
        { label: "Program", field: "program_name", sort: "asc" },
        { label: "Branch", field: "branch", sort: "asc" },
        { label: "Mobile", field: "mobile", sort: "asc" },
        { label: "Gender", field: "gender", sort: "asc" },
        { label: "College", field: "college", sort: "asc" },
        { label: "Passout", field: "passout_year", sort: "asc" },
        { label: "Payment Status", field: "payment_status", sort: "asc" },
        // { label: "Action", field: "action" }  // NEW
      ],

      rows: registrations.map((r, index) => ({
        S_no: index + 1,
        roll_no: r.roll_no || "-",
        first_name: r.first_name || "-",
        course_name: r.course_name || "-",
        technology_name: r.technology_name || "-",
        program_name: r.program_name || "-",
        branch: r.branch?.[0] || "-",
        mobile: r.mobile || "-",
        gender: r.gender || "-",
        college: r.college || "-",
        passout_year: r.passout_year || "-",

        payment_status: r.payment_status === 1 ? "Active" : "Inactive",

        // action: (
        //   <Button
        //     color="primary"
        //     size="sm"
        //     onClick={() => navigate(`/update-payment-status-eligibility/${r._id}`)}
        //   >
        //     Edit
        //   </Button>
        // )
      })),

    }),
    [registrations]
  );

  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} transition={Bounce} />
      <Row>
        <Col md="12">
          <Card>
            <CardBody>
              <Row>
                <Col md="4">
                  <div className="mb-4">
                    <Label htmlFor="course">Select Course <span className="text-danger">*</span></Label>
                    <Select
                      value={selectedCourse}
                      onChange={handleSelectedCourse}
                      options={courseOptions}
                      classNamePrefix="select2-selection"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                </Col>
                <Col md="4">
                  <div className="mb-4">
                    <Label htmlFor="technology">Select Technology <span className="text-danger">*</span></Label>
                    <Select
                      value={selectedTechnology}
                      onChange={handleSelectedTechnology}
                      options={technologyOptions}
                      classNamePrefix="select2-selection"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                </Col>
                <Col md="4">
                  <div className="mb-4">
                    <Label htmlFor="passout-year">Passout Year <span className="text-danger">*</span></Label>
                    <Select
                      value={selectedPassoutYears}
                      options={passoutYearsOptions}
                      onChange={handlePassoutYears}
                      classNamePrefix="select2-selection"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                </Col>
              </Row>

              <Button color="primary" className="mt-3" onClick={handleRegistrations}>
                Submit
              </Button>
            </CardBody>
            {/* Loader while submitting */}
            {submitted && loading && (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "250px" }}>
                <MutatingDots
                  visible={true}
                  height="100"
                  width="100"
                  color="#2B3A4A"
                  secondaryColor="#2B3A4A"
                  radius="12.5"
                />
              </div>
            )}

            {/* Show table or empty message ONLY after submit and NOT loading */}
            {submitted && !loading && (
              <CardBody>
                <CardTitle className="h4 mb-2 pb-0">Student Registrations List</CardTitle>

                {/* Excel Download Button */}
                {registrations.length > 0 && (
                  <div className="d-flex gap-2 mb-3 justify-content-end">
                    <Button color="primary" onClick={downloadExcel}>
                      Download Excel
                    </Button>
                  </div>
                )}

                {/* Table or Empty Text */}
                {registrations.length > 0 ? (
                  <MDBDataTable responsive bordered data={data} />
                ) : (
                  <p className="text-center mt-3">No records found for this program.</p>
                )}
              </CardBody>
            )}


          </Card>
        </Col>
      </Row>
    </>
  );
};

export default connect(null, { setBreadcrumbItems })(StudentRegistrationsCourseWiseList);
